import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  StyledLabel,
  SemanticButton,
  ContainerPaginate,
  SemanticSelect,
} from "../styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../../../../components/Admin/Cupons/CuponsRelatorio/Back/index";
import ScrollingModal from "../ModalCupons";

const CuponsRelatorio = (props) => {
  const [cupons, setCupons] = useState([]);
  const [status, setStatus] = useState("Todos");
  const [search, setSearch] = useState("");
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [pages, setPages] = useState(0);
  //setando as options do select de andamento do cupom
  const andamentoOptions = [
    { key: "to", value: "to", text: "Todos" },
    { key: "at", value: "at", text: "Ativo" },
    { key: "in", value: "in", text: "Inativo" },
  ];

  useEffect(() => {
    if (dataFinal || dataInicial) {
      loadSearchData();
      return;
    }
    loadCupons();
  }, [currentPage, search, status]);

  //carregando os cupons para a pagina
  const loadCupons = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (status) {
        params.status = status;
      }

      if (search) {
        params.search = search;
      }

      const response = await api.get("admin/cupons", { params });
      const { cupons, count } = response.data;
      let array = { local: "cupom", texto: `listou os cupons` };
      await api.post("system_logs", { acao: JSON.stringify(array) });
      setCupons(cupons);
      setPages(Math.ceil(count / 50));
    } catch (err) {
      console.error(err, 69);
      swal("Não foi possível carregar os cupons", "", "").then((res) =>
        props.history.push("/")
      );
    }
  }, [currentPage, search, status]);

  const loadSearchData = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (status) {
        params.status = status;
      }

      if (search) {
        params.search = search;
      }
      const response = await api.get(
        `admin/cupons/search/${dataInicial}/${dataFinal}`,
        { params }
      );
      const { cupons, count } = response.data;

      setCupons(cupons);
      setPages(Math.ceil(count / 50));
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar todos os cupons", "", "").then((res) =>
        props.history.push("/")
      );
    }
  }, [search, dataInicial, dataFinal, currentPage, status]);

  const cleanAll = useCallback(() => {
    setSearch("");
    setDataInicial(Date);
    setDataFinal(Date);
    loadCupons();
  });

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title>Cupons Relatorio</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar cupons"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />

            <SemanticSelect
              placeholder="andamento do cupom"
              options={andamentoOptions}
              onChange={(e) => setStatus(e.target.value)}
            />
          </ContainerInputSearch>

          <ContainerInputSearch>
            <Input
              type="date"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
            />
            <StyledLabel>Até</StyledLabel>
            <Input
              type="date"
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
            <SemanticButton onClick={loadSearchData}>
              Buscar por data
            </SemanticButton>
            <SemanticButton onClick={cleanAll}>Limpar</SemanticButton>
          </ContainerInputSearch>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Código do Cupom{" "}
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Descrição </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Email </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>N° Uso </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Data </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Informacoes extras{" "}
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>

            <SemanticTable.Body>
              {cupons.map((cupom) => (
                <SemanticTable.Row key={cupom.codigo} cupom={cupom}>
                  <SemanticTable.Cell>{cupom.codigo}</SemanticTable.Cell>
                  <SemanticTable.Cell>{cupom.descricao}</SemanticTable.Cell>
                  <SemanticTable.Cell>{cupom.email}</SemanticTable.Cell>
                  <SemanticTable.Cell>{cupom.num_usos}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {cupom.data_sys.toString().substring(0, 10)}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <ScrollingModal cupon={cupom.codigo} />
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={pages}
              onPageChange={(e, f) => setCurrentPage(f.activePage)}
              page={currentPage}
            />
          </ContainerPaginate>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(CuponsRelatorio);
